import { useNavigate } from 'react-router';
import ArrowDownIcon from '~/images/icons/ArrowDown';
import { Colors } from '~/themes/colors';
import { IBackButtonProps } from './Types';

export const BackButton = ({ onClick, url, color = Colors.secondary_500 }: IBackButtonProps) => {
  const navigate = useNavigate();

  const handleOnClick = () => {
    if (onClick) {
      onClick();
    } else if (url) {
      navigate(url);
    } else {
      navigate(-1);
    }
  };

  return (
    <button
      className="button-reset"
      style={{
        display: 'flex',
        cursor: 'pointer',
        alignItems: 'center',
        width: 'fit-content',
      }}
      type="button"
      onClick={handleOnClick}
    >
      <div style={{ marginRight: 8, transform: 'rotate(90deg)' }}>
        <ArrowDownIcon color={color} />
      </div>
      <span
        className="f-dark"
        style={{
          color,
          fontWeight: 'bold',
          fontSize: 22,
          textAlign: 'left',
        }}
      >
        Back
      </span>
    </button>
  );
};
